import { useState, useEffect } from 'react';

import { Language, getSavedLanguage, isLanguage } from '../utils/lesson';

export const useLanguage = () => {
  const [showLanguageCard, setShowLanguageCard] = useState(false);

  useEffect(() => {
    const defaultLanguage = getSavedLanguage();
    if (!defaultLanguage) {
      setShowLanguageCard(true);
    }
  }, []);

  const changeDefaultLanguage = (language: Language) => {
    if (!isLanguage(language)) return;
    localStorage.setItem('defaultLanguage', language);
    setShowLanguageCard(false);
  };

  const clearDefaultLanguage = (e: React.MouseEvent) => {
    e.preventDefault();
    localStorage.removeItem('defaultLanguage');
    setShowLanguageCard(true);
  };

  return {
    showLanguageCard,
    changeDefaultLanguage,
    clearDefaultLanguage
  };
}; 